import React, { Component } from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom'
import { Button } from "react-bootstrap";
//import { actionCreators } from '../../store/SecurityStore';
import * as actions from '../../store/actions/auth';
import "./ProviderSelect.css";
import { withAlert } from 'react-alert';
import LoadingIndicatorLogin from '../LoadingIndicatorLogin';
import ViewUtils from "../ViewUtils";

//const handler = (state) => {
//    return {
//        userRoles: state.security.userRoles,
//        userDetails: state.security.userDetails,
//        isLoading: state.security.isLoading,
//        roleSet: state.security.roleSet,
//        error: state.security.error
//    };
//};

const utils = new ViewUtils();

class WorkplaceApprovalSelect extends Component {

    state = {
        selectedRole: "-1",
        message: "",
        loading: true
    };

    showAlert(msg, msgType) {
        this.props.alert.show(msg, {
            timeout: 3000, // custom timeout just for this one alert
            type: msgType,
            onOpen: () => {
                //console.log('open')
            }, // callback that will be executed after this alert open
            onClose: () => {
                //console.log('closed')
            } // callback that will be executed after this alert is removed
        })
    }

    //validateForm() {
    //    return this.state.selectedRole !== null;
    //}

    componentDidMount() {
    }

    componentDidUpdate(prevProps) {
        if (prevProps.roleSet !== this.props.roleSet && this.props.roleSet) {
            clearTimeout(this.props.userLoginTimer);
            this.props.onGetMenuPermissions();
            //this.props.history.push('/home');
        }

        if (prevProps.menuPermissions !== this.props.menuPermissions && this.props.menuPermissions) {
            //this.props.history.push('/home');
            this.props.history.push(this.props.dashboardURL);
        }

        if (prevProps.loginRedirectToLogin !== this.props.loginRedirectToLogin && this.props.loginRedirectToLogin) {
            //this.props.history.push('/login');
            this.props.history.push(this.props.loginRedirectToLoginPath);
        }

        if (prevProps.loginErrorMessage !== this.props.loginErrorMessage && this.props.loginErrorMessage) {
            this.showAlert(this.props.loginErrorMessage, 'error');
        }

        if (prevProps.loginMessage !== this.props.loginMessage && this.props.loginMessage) {
            this.showAlert(this.props.loginMessage, 'error');
        }
    }

    back() {
        clearTimeout(this.props.userLoginTimer);
        this.props.history.push('/role');
    }

    select() {
        this.setState({ message: "" });
        this.props.onSelectWorkplaceApproval(this.props.userDetails.UserKey, this.props.userDetails.RoleKey, this.state.selectedWorkplaceApproval);
    }

    render() {
        return (
            <div className="role-container">
                <div className="RoleSelect">
                    <p className="errorMessage">{this.state.message}</p>
                    <p>Select a Workplace Approval</p>
                    <form className="style-2" id="scroll">
                        {this.props.userWorkplaceApprovals.map(userWorkplaceApproval => (
                            <div className="form-check" key={userWorkplaceApproval.Id}>
                                <label>
                                    <input type="radio"
                                        value={userWorkplaceApproval.Id}
                                        checked={this.state.selectedWorkplaceApproval === userWorkplaceApproval.Id.toString()}
                                        onChange={(ev) => this.setState({ selectedWorkplaceApproval: ev.target.value })}
                                    />
                                    <span className="label-text"> {userWorkplaceApproval.Name} </span>
                                </label>
                            </div>
                        ))}
                    </form>
                    <table>
                        <tbody>
                            <tr>
                                <td>
                                    <Button
                                        block
                                        onClick={this.back.bind(this)}
                                        type="button"
                                    >
                                        BACK
                                    </Button>
                                </td>
                                <td>
                                    <Button
                                        block
                                        onClick={this.select.bind(this)}
                                        className="role-btn"
                                        disabled={this.state.selectedWorkplaceApproval === "-1" || this.props.isLoading}
                                        type="button"
                                    >
                                        NEXT
                                    </Button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <br />
                </div>
                <LoadingIndicatorLogin show={this.props.isLoading} />
            </div>
        );
    }
}

//export default withRouter(
//    connect(
//        handler,
//        dispatch => bindActionCreators(actionCreators, dispatch)
//    )(RoleSelect)
//);

const mapStateToProps = state => {
    return {
        isLoading: state.auth.isLoading,
        userDetails: state.auth.userDetails,
        authenticated: !utils.isNull(state.auth.userDetails) ? state.auth.userDetails.Authenticated : false,
        otpSent: !utils.isNull(state.auth.userDetails) ? state.auth.userDetails.OTPSent : false,
        loginMessage: !utils.isNull(state.auth.userDetails) ? state.auth.userDetails.Message : null,
        userWorkplaceApprovals: !utils.isNull(state.auth.userDetails) ? !utils.isNull(state.auth.userDetails.WorkplaceApprovals) ? state.auth.userDetails.WorkplaceApprovals : [] : [],
        loginErrorMessage: state.auth.errorMessage,
        loginRedirectToLogin: state.auth.redirectToLogin,
        userLoginTimer: state.auth.userLoginTimer,
        roleSet: !utils.isNull(state.auth.userDetails) ? !utils.isNull(state.auth.userDetails.Token) ? true : false : false,
        menuPermissions: !utils.isNull(state.auth.menuPermissionsDetails) ? true : false,
        loginRedirectToLoginPath: state.auth.loginRedirectToLoginPath,
        dashboardURL: !utils.isNull(state.auth.menuPermissionsDetails) ? state.auth.menuPermissionsDetails.DashboardInfo.DashboardURL : null,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onSelectWorkplaceApproval: (UserKey, RoleKey, WorkplaceApprovalKey) => dispatch(actions.authWorkplaceApprovalSelect(UserKey, RoleKey, WorkplaceApprovalKey)),
        onGetMenuPermissions: () => dispatch(actions.authMenuPermission())
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withAlert()(WorkplaceApprovalSelect)));
